import { KubeCluster } from 'common/graphqlTypes';
import ClusterTable from 'components/overview/LogOverviewPage/LogOverviewClusterTable';
import { numericStringCompare } from 'common/util/string';

/**
 * List of clusters on the log overview page
 */

type ClustersListProps = {
  clusters: Array<KubeCluster>;
};

function ClustersList({ clusters }: ClustersListProps): JSX.Element {
  // sort clusters alphabetically
  clusters.sort((a, b) => numericStringCompare(a.name, b.name));
  const allClusterTables = clusters.map((cluster: KubeCluster, index: number) => (
    <ClusterTable key={cluster.name} cluster={cluster} index={index} />
  ));
  return <>{allClusterTables}</>;
}

export default ClustersList;
